// eslint-disable-next-line no-shadow
export enum StudioLeftSidebarPopoverViews {
	FLUX = 'flux',
	MAGIC = 'magicmode',
	PROMODE = 'promode',
}
